export const getNestedValue = (obj, path) => {
  if (!path) return obj;
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
};

export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};